<app-main-top *ngIf="!topService.isMobile"></app-main-top>
<app-main-top-mobile *ngIf="topService.isMobile"></app-main-top-mobile>
<app-main-body></app-main-body>
<app-login-popup *ngIf="userService?.leadProfile?.leadId"></app-login-popup>
<app-version-notifier ></app-version-notifier>
<app-pricelist-loader *ngIf="topService.isDowloadPriceUrl ||
(topService.isExporting && !topService.isMobile)">
</app-pricelist-loader>
